'use client'

import {observer} from 'mobx-react'
import {useRouter} from 'nextjs-toploader/app'
import React from 'react'

import {Routes} from '@/src/config/routes'
import {isProductViewModelWithVariants} from '@/src/entities/product/helpers/validators'
import * as UI from '@/src/features/catalog/product-list/product-list-item.styled'
import {useBasket} from '@/src/entities/basket'
import IconBasket from '@/src/shared/ui/icons/basket'
import {useProductListItem} from '@/src/features/catalog/product-list/product-list-item.provider'

export const ProductBuyButtonContainer = observer(() => {
  const router = useRouter()
  const basket = useBasket()

  const productListItemVM = useProductListItem()

  if (!productListItemVM) throw Error('Product item view model does not found in list')

  const inBasket = basket.haveProduct(
    productListItemVM.product,
    isProductViewModelWithVariants(productListItemVM)
      ? (productListItemVM.variants.variant ?? undefined)
      : undefined,
  )

  return (
    <>
      {productListItemVM.price && productListItemVM.available && (
        <UI.ProductBuyBtn
          data-testid="buy-btn"
          onClick={async () => {
            if (inBasket) {
              router.push(Routes.basket.page)
            } else {
              if (isProductViewModelWithVariants(productListItemVM)) {
                await productListItemVM.onClickBuyButton('mobile')
              } else {
                await productListItemVM.onClickBuyButton()
              }
            }
          }}>
          {(!inBasket && 'Купить') || (
            <>
              <UI.InBasketIcon as={IconBasket} />
              <UI.InBasketLabel>В корзину</UI.InBasketLabel>
            </>
          )}
        </UI.ProductBuyBtn>
      )}

      {productListItemVM.price && productListItemVM.available && (
        <UI.ProductBuyBtnWithVariant
          data-testid="buy-btn"
          onClick={async () => {
            if (inBasket) {
              router.push(Routes.basket.page)
            } else {
              if (isProductViewModelWithVariants(productListItemVM)) {
                await productListItemVM.onClickBuyButton('desktop')
              } else {
                await productListItemVM.onClickBuyButton()
              }
            }
          }}>
          {(!inBasket && 'Купить') || (
            <>
              <UI.InBasketIcon as={IconBasket} />
              <UI.InBasketLabel>В корзину</UI.InBasketLabel>
            </>
          )}
        </UI.ProductBuyBtnWithVariant>
      )}
    </>
  )
})
